.customer-organization-form__device-limit-inputs-container {
  width: 360px;
}
